import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import moment from "moment";

import "./ChitInfo.css";
import { NavLink } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import { motion } from "framer-motion";
import "./Chitgroup.css";
import AgentSide from "../agentcompo/AgentSide";
import userimage from "./images/userimage.png"
import { AgentContext } from "../context/agentcontext";

const Agentchitinfo = () => {
  const usernamedashboard = localStorage.getItem("username");
  const [user, setuser] = useState({});
  const { groupId } = useParams();
  const history = useNavigate();
  const { agentname } = useContext(AgentContext);
  const [loguser, setLoguser] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  const dltchit = async (groupId) => {
    const confirmation = window.confirm(
      "Deleting this chit group will also delete all related auction, bidding, and payment data. Do you want to proceed?"
    );
    if (!confirmation) {
      return;
    }

    console.log(groupId);
    try {
      const res = await axios.delete(
        `http://localhost:5001/api/delete/chitgroup/${groupId}`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (res.data.status == 201) {
        history("/agentchits");
      }
    } catch (error) {
      console.error("Error deleting chit group:", error);
      // setErrorMessage("Cannot delete chit group. Please ensure all related auction details are removed first.");
      setErrorMessage(
        error.response.data.error ||
          "Cannot delete chit group. Please ensure all related auction details are removed first."
      );
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getchitid/${groupId}`
        );
        setuser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchData();
  }, [groupId]);

  useEffect(() => {
    const fetchnameData = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5001/api/getmemberdetails/afterlogin/${usernamedashboard}`
        );
        setLoguser({ ...response.data[0] });
      } catch (error) {
        console.error("Error fetching assessment data", error);
      }
    };
    fetchnameData();
  }, [usernamedashboard]);

  const closeErrorMessage = () => {
    setErrorMessage("");
  };

  return (
    <div style={{ display: "flex", overflow:"hidden" }}>
      <div>
        <AgentSide />
      </div>
      <div className="C-ttd">
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="C-courses1"
        >
          <div className="info-courses1-head">
            <div className="h">
              <NavLink style={{ color: "black" }} to={"/agentchits"}>
                <FaArrowLeftLong className="Agent-Arrow" />
              </NavLink>
              <div className="dash-heading">
                <h2>Information</h2>
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px" ,marginRight:"30px" }}>
            <div  className="image">
              <div>
                <img
                // src={user.uploadPhoto? `http://localhost:5001/uploads/${user.uploadPhoto}` : userimage}
                  src={`http://localhost:5001/uploads/${loguser.uploadPhoto}`}
                  alt=""
                  style={{
                    height: "50px",
                    borderRadius: "30px",
                    width: "50px",
                  }}
                  className="images"
                ></img>
              </div>
              <div>
                <p style={{ margin: "0px" }}>{loguser.UserName}</p>
                <p style={{ margin: "0px" }}>({loguser.role})</p>
              </div>
            </div>
          </div>
</div>
          <hr style={{ margin: "10px 0px" }}></hr>

          <div className="ag-but-de">
            <button onClick={() => dltchit(user.groupId)} className="ag-but-delete">
              Delete
            </button>
          </div>
          <div className="info-container">
            <div className="info-display-full-2">
              <div className="ph">
                <div className="info-display-22">
                  <label>
                    <strong>GroupId</strong>
                  </label>
                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.groupId}
                    placeholder="Group Id:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>GroupName</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                     class="info-input-22"
                    value={user.groupName}
                    placeholder="Group Name:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>Auction Type</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.auctionType}
                    placeholder="Auction Type:"
                  />
                </div>
              </div>
              <div className="ph">
                <div className="info-display-22">
                  <label>
                    <strong>startDate</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                     class="info-input-22"
                    value={user.startDate}
                    placeholder="Start Date:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>Chit Amount</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.chitAmount}
                    placeholder="Chit Amount:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>No.of Installments</strong>
                  </label>

                  <input
                    type="int"
                    name="text"
                    class="info-input-22"
                    value={user.noOfInstallments}
                    placeholder="No of Installments:"
                  />
                </div>
              </div>
              <div className="ph">
                <div className="info-display-22">
                  <label>
                    <strong>EndDate</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.endDate}
                    placeholder="End Date:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>No.of users</strong>
                  </label>

                  <input
                    type="int"
                    name="text"
                     class="info-input-22"
                    value={user.noOfUsers}
                    placeholder="No of users:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>Commission</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                     class="info-input-22"
                    value={user.commission}
                    placeholder="Commission:"
                  />
                </div>
              </div>
              <div className="ph">
                <div className="info-display-22">
                  <label>
                    <strong>AuctionDate</strong>
                  </label>
                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.auctionDate}
                    placeholder="Auction Date:"
                  />
                </div>
                <div className="info-display-22">
                  <label>
                    <strong>CreatedBy</strong>
                  </label>
                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={user.createdby}
                    placeholder="Auction Date:"
                  />
                </div>

                <div className="info-display-22">
                  <label>
                    <strong>Chit creation date</strong>
                  </label>

                  <input
                    type="text"
                    name="text"
                    class="info-input-22"
                    value={moment(user.dateOfCreation).format("DD-MM-YYYY")}
                    placeholder="chit creation Date:"
                  />
                </div>
              </div>
              <div className="info-display-22">
                <label>
                  <strong>Chit status</strong>
                </label>
                <input
                  type="text"
                  name="text"
                class="info-input-22"
                  value={user.chitstatus}
                  placeholder="Auction Date:"
                />
              </div>
            </div>
          </div>
          {errorMessage && (
            <div className="info-popup">
              <div className="info-popup-inner">
                {/* <span className="close" onClick={closeErrorMessage}>
                &times;
              </span> */}
                <h3 className="info-popupheading">Warning!</h3>
                <p>{errorMessage}</p>
                <button className="info-popup-close" onClick={closeErrorMessage}>
                  Close
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </div>
    </div>
    // </div>
    // </div>
  );
};

export default Agentchitinfo;
